import { useEventBus as o } from "@vueuse/core";
import { ref as s } from "vue";
const e = Symbol(), r = o(e), m = s(!1);
export {
  m as hasLazyLoaded,
  r as lazyBus
};
